import { gateway } from "../../../../gateway";
import type { IInvoice } from "../../create/interfaces/invoice.interfaces";

export const resendInvoiceAction = async (invoiceUid: string, companyId: number): Promise<unknown> => {
  const response = await gateway.post(`/invoices/${invoiceUid}/resend`, {}, { headers: { "x-company-id": String(companyId) } });
  return (response.data as any)?.data;
};

export const updateInvoiceAction = async (invoiceUid: string, companyId: number, patch: Partial<IInvoice>): Promise<IInvoice> => {
  const response = await gateway.patch(`/invoices/${invoiceUid}`, patch, { headers: { "x-company-id": String(companyId) } });
  return (response.data as any)?.data as IInvoice;
};

export const updateInvoiceRecipientsAction = async (invoiceUid: string, companyId: number, emailRecipients: IInvoice["emailRecipients"]): Promise<IInvoice> => {
  const response = await gateway.patch(`/invoices/${invoiceUid}/recipients`, { emailRecipients }, { headers: { "x-company-id": String(companyId) } });
  return (response.data as any)?.data as IInvoice;
};
